module.exports = __webpack_public_path__ + "static/img/次元兽决战3.c9d21a8c.png";